import React from 'react';
import './App.css';
import Hero from './components/Hero';
import Story from './components/Story';
import Movement from './components/Movement';
import CreatorProgram from './components/CreatorProgram';
import DonorLeaderboard from './components/DonorLeaderboard';
import CallToAction from './components/CallToAction';
import Snowfall from './components/Snowfall';
import { FaSnowflake } from 'react-icons/fa';

function App() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      <Snowfall />

      <Hero />
      <Story />
      <CreatorProgram />
      <Movement />
      <DonorLeaderboard />
      <CallToAction />

      <footer className="bg-rizzmas-dark border-t border-rizzmas-green/20 py-8">
        <div className="max-w-7xl mx-auto px-4 text-center text-rizzmas-cream/60">
          <p className="flex items-center justify-center gap-2">
            RizzmasCTO - The Community Takeover
            <FaSnowflake className="text-rizzmas-cream text-xl" />
          </p>
          <p className="mt-2 text-sm">Join the memecoin - Join the movement #RizzmasCTO</p>
          <p className="mt-4 text-xs text-rizzmas-cream/40 max-w-4xl mx-auto">
            Disclaimer: RizzmasCTO is an entertainment token only, no guarantees of financial return. Rizzmas tokens are valueless digital collectibles with majority of the supply held by the team between 100 wallets. All liquidations are at the team's discretion.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
